import { databasesToContentId } from './constants.ts';
import { databaseWithTagField } from './database-with-tag-field.ts';
import { getDatabaseViewOnly } from './databaseViewOnly.ts';
import { getDatabaseWithAttachments } from './databaseWithAttachments.ts';
import { databaseWithBasicFields } from './databaseWithBasicFields.ts';
import { getDatabaseWithContent } from './databaseWithContent.ts';
import { getDatabaseWithFilters } from './databaseWithFilters.ts';
import { getDatabaseWithJiraIssueFieldsAndComments } from './databaseWithJiraIssueFieldsAndComments.ts';
import { getDatabaseWithJiraIssuePopoverFields } from './databaseWithJiraIssuePopoverFields.ts';
import {
  getDatabaseWithRichContent,
  getDatabaseWithRichContentOverflow
} from './databaseWithRichContent.ts';
import { getDatabaseWithSampleCsvManyRows } from './databaseWithSampleCsvManyRows.ts';
import { getDatabaseWithSampleCsvStructure } from './databaseWithSampleCsvStructure.ts';
import { getDatabaseWithSmallCsvStructureWithUgc } from './databaseWithSampleCsvStructureWithUgc.ts';
import { getDatabaseWithSelfReferenceEntryLinkField } from './databaseWithSelfReferenceEntryLinkField.ts';
import { getDatabaseWithUserAndLinkField } from './databaseWithUserAndLinkField.ts';
import { databaseWithUserField } from './databaseWithUserField.ts';
import { databaseWithViewsOverflow } from './databaseWithViewsOverflow.ts';
import { getEmptyDatabase } from './emptyDatabase.ts';

export default {
  emptyDatabase: {
    database: getEmptyDatabase(),
    contentId: databasesToContentId['emptyDatabase']
  },
  databaseWithViewsOverflow: {
    database: databaseWithViewsOverflow(),
    contentId: databasesToContentId['databaseWithViewsOverflow']
  },
  databaseWithSampleCsvStructure: {
    database: getDatabaseWithSampleCsvStructure(),
    contentId: databasesToContentId['databaseWithSampleCsvStructure']
  },
  databaseWithSampleCsvStructureWithUgc: {
    database: getDatabaseWithSmallCsvStructureWithUgc(),
    contentId: databasesToContentId['databaseWithSampleCsvStructureWithUgc']
  },
  databaseWithSampleCsvManyRows: {
    database: getDatabaseWithSampleCsvManyRows(),
    contentId: databasesToContentId['databaseWithSampleCsvManyRows']
  },
  databaseWithContent: {
    database: getDatabaseWithContent(),
    contentId: databasesToContentId['databaseWithContent']
  },
  databaseWithUserField: {
    database: databaseWithUserField(),
    contentId: databasesToContentId['databaseWithUserField']
  },
  databaseWithBasicFields: {
    database: databaseWithBasicFields(),
    contentId: databasesToContentId['databaseWithBasicFields']
  },
  databaseWithUserAndLinkField: {
    database: getDatabaseWithUserAndLinkField(),
    contentId: databasesToContentId['databaseWithUserAndLinkField']
  },
  databaseWithSelfReferenceEntryLinkField: {
    database: getDatabaseWithSelfReferenceEntryLinkField(),
    contentId: databasesToContentId['databaseWithSelfReferenceEntryLinkField']
  },
  databaseWithFilters: {
    database: getDatabaseWithFilters(),
    contentId: databasesToContentId['databaseWithFilters']
  },
  databaseViewOnly: {
    database: getDatabaseViewOnly(),
    contentId: databasesToContentId['databaseViewOnly']
  },
  databaseWithJiraIssueFieldsAndComments: {
    database: getDatabaseWithJiraIssueFieldsAndComments(),
    contentId: databasesToContentId['databaseWithJiraIssueFieldsAndComments']
  },
  databaseWithAttachments: {
    database: getDatabaseWithAttachments(),
    contentId: databasesToContentId['databaseWithAttachments']
  },
  databaseWithRichContent: {
    database: getDatabaseWithRichContent(),
    contentId: databasesToContentId['databaseWithRichContent']
  },
  databaseWithRichContentOverflow: {
    database: getDatabaseWithRichContentOverflow(),
    contentId: databasesToContentId['databaseWithRichContentOverflow']
  },
  databaseWithTagField: {
    database: databaseWithTagField(),
    contentId: databasesToContentId['databaseWithTagField']
  },
  databaseWithJiraIssuePopoverSingle: {
    database: getDatabaseWithJiraIssuePopoverFields({
      contentId: databasesToContentId['databaseWithJiraIssuePopoverSingle'],
      variant: 'single'
    }),
    contentId: databasesToContentId['databaseWithJiraIssuePopoverSingle']
  },
  databaseWithJiraIssuePopoverMulti: {
    database: getDatabaseWithJiraIssuePopoverFields({
      contentId: databasesToContentId['databaseWithJiraIssuePopoverMulti'],
      variant: 'multi'
    }),
    contentId: databasesToContentId['databaseWithJiraIssuePopoverMulti']
  }
};
